import Layout from "modules/layout/dashboard"
import { useInvoiceId, useMemberId } from "pages/member"
import { useMember } from "pages/member/queries"
import { useInvoice, usePayInvoice } from "../../queries"
import {
  Button,
  Card,
  Col,
  message,
  Result,
  Row,
  Space,
  Typography,
} from "antd"
import { useTranslation } from "react-i18next"
import { CreditCard, PaymentForm } from "react-square-web-payments-sdk"
import { useNavigate } from "react-router-dom"
import { useEffect } from "react"
import { ReactComponent as DownloadIcon } from "assets/icons/download.svg"

const { Main } = Layout
const { Title } = Typography

const Pay: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const memberId = useMemberId()
  const invoiceId = useInvoiceId()
  const member = useMember(memberId)
  const invoice = useInvoice(memberId!, invoiceId!)
  const [messageApi, contextHolder] = message.useMessage()
  const { mutate, isLoading, isSuccess } = usePayInvoice(invoiceId!, {
    onSuccess: () => {
      messageApi.success({
        key: "paying",
        content: t("invoice.payment_success"),
      })
    },
  })

  useEffect(() => {
    invoice.data &&
      ["paid", "recoverable", "canceled"].includes(invoice.data?.status!) &&
      navigate("../..")
  }, [invoice.data])

  return (
    <>
      {contextHolder}
      <Main.PageHeader
        breadcrumbs={[
          {
            title: member.data?.name,
            link: `/members/${member.data?.id}/events`,
          },
          { title: "Factures", link: `/members/${member.data?.id}/invoices` },
          {
            title:
              invoice.data?.reference ??
              invoice.data?.proforma_reference ??
              "-",
            link: `/members/${member.data?.id}/invoices/${invoice.data?.id}`,
          },
          {
            title: t("invoice.payment"),
            link: `/members/${member.data?.id}/invoices/${invoice.data?.id}/payment`,
          },
          {
            title: t("invoice.text_1"),
          },
        ]}
        title={
          <Title level={3}>
            {t("invoice.text_1", {
              entity:
                invoice.data?.reference ??
                invoice.data?.proforma_reference ??
                "-",
            })}
          </Title>
        }
      />
      <Card style={{ width: "100%" }}>
        {isSuccess ? (
          <Result
            status="success"
            title={t("invoice.payment_success")}
            extra={
              <Button
                type="primary"
                onClick={() =>
                  window.open(
                    new URL(
                      `operation/administration/members/${memberId}/invoices/${invoiceId}/export`,
                      process.env.REACT_APP_API_URL
                    ).href
                  )
                }
              >
                <Space align="center">
                  <DownloadIcon />
                  {t("global.download")}
                </Space>
              </Button>
            }
          />
        ) : (
          <Row>
            <Col md={11} sm={24}>
              <PaymentForm
                applicationId={process.env.REACT_APP_SQUARE_APP_ID as string}
                locationId={process.env.REACT_APP_SQUARE_LOCATION_ID as string}
                cardTokenizeResponseReceived={async (token) => {
                  mutate({ source_id: token.token! })
                  messageApi.loading({
                    key: "paying",
                    content: t("global.processing"),
                    duration: 0,
                  })
                }}
              >
                <CreditCard
                  buttonProps={{
                    isLoading,
                  }}
                >
                  {t("invoice.paye")}
                </CreditCard>
              </PaymentForm>
            </Col>
          </Row>
        )}
      </Card>
    </>
  )
}
export default Pay
